const state = () => ({
  msalConfig: {
    auth: {
      clientId: process.env.VUE_APP_CLIENT_ID,
      authority:
        "https://login.microsoftonline.com/566b5a42-12ce-48e9-84d9-3569a16668f4",
      redirectUri: process.env.VUE_APP_REDIRECT_URI,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    },
  },
  accessToken: "",
});

const mutations = {
  setAccesToken(state, token) {
    state.accessToken = token;
  },
};

const actions = {
  setAccessToken({ commit }, value) {
    commit("setAccessToken", value);
  },
};

const getters = {
  getAccessToken(state) {
    return state.accessToken;
  },

  getMsalConfig(state) {
    return state.msalConfig;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
